export default function getAttr(oAbc,attr){
    let value=0;
    if(!oAbc){
        return
    }
    if(oAbc.currentStyle) {
        value=oAbc.currentStyle[attr];
    } else {
        value=getComputedStyle(oAbc,null)[attr]
    }
    return value
};